import { getCurrentUser } from './auth'

interface ClientErrorPayload {
  message: string
  stack?: string
  digest?: string
  componentStack?: string
  source: 'error-boundary' | 'global-error' | 'route-error' | 'window-error' | 'unhandled-rejection'
}

/** Fire-and-forget report to the backend so a crash is visible in server logs even when
 * nobody happens to be looking at the affected user's browser console. Must never itself
 * throw or block — this runs from inside error-handling paths. */
export function reportClientError(payload: ClientErrorPayload): void {
  try {
    // Errors thrown inside browser extensions (e.g. chrome-extension://...) are not ours and
    // can flood the alerts, so skip them.
    if (payload.stack && /(chrome|moz|safari-web)-extension:\/\//.test(payload.stack)) return
    const baseUrl = process.env.NEXT_PUBLIC_BACKEND_URL || 'http://localhost:8000'
    const user = getCurrentUser()
    const body = JSON.stringify({
      message: payload.message,
      stack: payload.stack,
      digest: payload.digest,
      component_stack: payload.componentStack,
      url: typeof window !== 'undefined' ? window.location.href : undefined,
      user_agent: typeof navigator !== 'undefined' ? navigator.userAgent : undefined,
      company: typeof window !== 'undefined' ? (localStorage.getItem('cognito_selected_company') || undefined) : undefined,
      user_sub: user?.sub,
      source: payload.source,
    })

    fetch(`${baseUrl}/api/v1/client-errors`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body,
      keepalive: true,
    }).catch(() => {})
  } catch {
    // Reporting must never itself crash the error path.
  }
}
